import React from 'react';
import { FileText } from 'lucide-react';
import { LegalMarkdownPage } from './LegalMarkdownPage';

interface TermsOfServiceProps {
  onBack?: () => void;
}

export function TermsOfService({ onBack }: TermsOfServiceProps) {
  const [markdown, setMarkdown] = React.useState<string>('');
  const [loadError, setLoadError] = React.useState<string | null>(null);

  React.useEffect(() => {
    let cancelled = false;
    fetch('/legal/terms-of-service.md')
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to load terms: ${res.status}`);
        return res.text();
      })
      .then((text) => {
        if (!cancelled) setMarkdown(text);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setLoadError(err instanceof Error ? err.message : 'Failed to load Terms of Service.');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <LegalMarkdownPage
      onBack={onBack}
      title="Terms of Service"
      subtitle="Please read these terms carefully before using our services. By accessing our platform, you agree to be bound by these terms."
      icon={FileText}
      headerAccent="purple"
      documentAccent="purple"
      documentTitle="Terms of Service"
      markdown={loadError ? `Failed to load the Terms of Service.\n\n${loadError}\n` : markdown || 'Loading Terms of Service…'}
    />
  );
}